import { Dispatch, Fragment, SetStateAction } from "react";
import { FilterFields, FilterFieldsKeys } from "../../../types/FilterFields";
import ChainNameSingleSelection from "./components/ChainNameSingleSelection";
import CurrencySingleSelection from "./components/CurrencySingleSelection";
import { genField } from "src/utils/HelperComp";
import { useTranslation } from "src/hooks";
import WalletAddressTextField from "./components/WalletAddressTextField";
import { cleanStrArray } from "src/utils/helper";
import { Iprefix } from "src/hooks/useTranslation";

function useRenderFilterFields({
  translatePrefix,
  fields,
  setFields,
}: {
  translatePrefix: Iprefix;
  fields: FilterFields;
  setFields: Dispatch<SetStateAction<FilterFields>>;
}) {
  const { t } = useTranslation(translatePrefix);

  const filterFields = genField({ t }, [
    [
      FilterFieldsKeys.ChainName,
      <ChainNameSingleSelection
        value={fields[FilterFieldsKeys.ChainName]}
        onChange={(value) => {
          setFields((fields) => ({
            ...fields,
            [FilterFieldsKeys.ChainName]: value,
            [FilterFieldsKeys.Currency]: "",
          }));
        }}
      />,
    ],
    [
      FilterFieldsKeys.Currency,
      <CurrencySingleSelection
        value={fields[FilterFieldsKeys.Currency]}
        onChange={(value) => {
          setFields((fields) => ({
            ...fields,
            [FilterFieldsKeys.Currency]: value,
          }));
        }}
        chainName={fields[FilterFieldsKeys.ChainName]}
      />,
    ],
    [
      FilterFieldsKeys.WalletAddress,
      <WalletAddressTextField
        value={fields[FilterFieldsKeys.WalletAddress]}
        onChange={(value) => {
          setFields((fields) => ({
            ...fields,
            [FilterFieldsKeys.WalletAddress]: value,
          }));
        }}
        count={
          cleanStrArray(fields[FilterFieldsKeys.WalletAddress].split(","))
            .length
        }
      />,
    ],
  ]);

  const renderFields = () =>
    Object.keys(filterFields).map((key, index) => (
      <Fragment key={index}>{filterFields[key]}</Fragment>
    ));

  return { renderFields };
}

export default useRenderFilterFields;
